import { PropTypes } from 'prop-types';

export const addressInfo = PropTypes.arrayOf(
	PropTypes.shape({
		addressId: PropTypes.number,
		addresstype: PropTypes.string,
		city: PropTypes.string,
		country: PropTypes.string,
		line1: PropTypes.string,
		line2: PropTypes.string,
		line3: PropTypes.any,
		primary: PropTypes.bool,
		state: PropTypes.string,
		zipcode: PropTypes.string,
	})
);

export const basicEmailInfo = PropTypes.arrayOf(
	PropTypes.shape({
		addressId: PropTypes.number,
		emailId: PropTypes.string,
		emailtype: PropTypes.string,
		primary: PropTypes.bool,
	})
);

export const basicRelatedDonor = PropTypes.arrayOf(
	PropTypes.shape({
		name: PropTypes.string,
		relationship: PropTypes.string,
	})
);

export const basicPhoneInfo = PropTypes.arrayOf(
	PropTypes.shape({
		addressId: PropTypes.number,
		phonenumber: PropTypes.string,
		phonetype: PropTypes.string,
		primary: PropTypes.bool,
	})
);

export const basicInfo = PropTypes.shape({
	addresses: addressInfo,
	deliveryMethod: PropTypes.string,
	dob: PropTypes.string,
	emails: basicEmailInfo,
	firstname: PropTypes.string,
	gender: PropTypes.string,
	lastname: PropTypes.string,
	middlename: PropTypes.string,
	phones: basicPhoneInfo,
	primary: PropTypes.bool,
	relatedDonor: basicRelatedDonor,
	ssn: PropTypes.string,
	suffix: PropTypes.string,
	title: PropTypes.string,
});

export const basicImports = PropTypes.arrayOf(
	PropTypes.shape({
		value: PropTypes.string,
		desc: PropTypes.string,
	})
);

export const dataLegacy = PropTypes.shape({
	legacyOptions: PropTypes.arrayOf(
		PropTypes.shape({
			optionId: PropTypes.number,
			optionName: PropTypes.string,
			percentage: PropTypes.string,
		})
	),
});

export const basicLegacy = PropTypes.arrayOf(
	PropTypes.shape({
		optionId: PropTypes.number,
		optionName: PropTypes.string,
		percentage: PropTypes.string,
	})
);

export const basicSingleLegacy = PropTypes.shape({
	optionId: PropTypes.number,
	optionName: PropTypes.string,
	percentage: PropTypes.string,
});

export const basicTempData = PropTypes.shape({
	tempJSON: PropTypes.shape({
		advisors: PropTypes.arrayOf(basicInfo),
		existingUser: PropTypes.bool,
		fundName: PropTypes.string,
		legacyOptions: basicLegacy,
		referralCode: PropTypes.shape({
			comment: PropTypes.string,
			referralCodeValue: PropTypes.string,
		}),
		ssn: PropTypes.string,
		userId: PropTypes.string,
	}),
});

export const basicAlertContents = PropTypes.arrayOf(
	PropTypes.shape({
		field_alert_button1_link: PropTypes.string,
		field_alert_button1_text: PropTypes.string,
		field_alert_button2_link: PropTypes.string,
		field_alert_button2_text: PropTypes.string,
		field_description: PropTypes.string,
		field_header: PropTypes.string,
		field_page: PropTypes.string,
		name: PropTypes.string,
	})
);

export const basicDropDownShape = PropTypes.shape({
	addressType: basicImports,
	countries: basicImports,
	dollarPotential: PropTypes.any,
	emailType: basicImports,
	gender: basicImports,
	phoneType: basicImports,
	relationship: basicImports,
	states: basicImports,
	suffix: basicImports,
	title: basicImports,
});

export const basicWebAccessInfo = PropTypes.shape({
	fundName: PropTypes.any,
	userId: PropTypes.string,
});

export const basicSuccessorsAddress = PropTypes.shape({
	city: PropTypes.string,
	country: PropTypes.string,
	line1: PropTypes.string,
	line2: PropTypes.string,
	line3: PropTypes.string,
	state: PropTypes.string,
	zip: PropTypes.string,
	zipTitle: PropTypes.string,
});

export const basicSuccessorsInfo = PropTypes.shape({
	address: basicSuccessorsAddress,
	dob: PropTypes.string,
	firstName: PropTypes.string,
	gender: PropTypes.string,
	key: PropTypes.string,
	lastName: PropTypes.string,
	middleName: PropTypes.string,
	preferedEmail: PropTypes.string,
	preferedPhone: PropTypes.string,
	relationshipType: PropTypes.string,
	suffix: PropTypes.string,
	title: PropTypes.string,
});

export const basicStepperConfig = PropTypes.arrayOf(
	PropTypes.shape({
		description: PropTypes.string,
		key: PropTypes.number,
		pageName: PropTypes.string,
		route: PropTypes.string,
		status: PropTypes.string,
	})
);
